// extracted by mini-css-extract-plugin
module.exports = {"pyramid":"pyramid_pyramid__3GVhi","not-visible":"pyramid_not-visible__1Goen","visible":"pyramid_visible__29HsL"};